import React from 'react';

import { css, styled, Tooltip } from '@mui/material';
import { useElementSize } from 'usehooks-ts';

import { TooltipTitle } from './styles';
import { type Instructor } from './types';

const InstructorsParent = styled('div')`
    position: relative;
`;

const SharedCSS = css`
    white-space: nowrap;

    span:not(:last-child) {
        margin-right: 0.5rem;

        ::after {
            content: ',';
        }
    }
`;

const MeasureWidth = styled('span')`
    ${SharedCSS};
    position: absolute;
    pointer-events: none;
    opacity: 0;
`;

const StyledInstructors = styled('div')<{ $maxWidth: number }>`
    ${SharedCSS};
    max-width: ${(props) => props.$maxWidth}px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

interface InstructorsProps {
    instructors: Instructor[];
}

const Instructors: React.FC<InstructorsProps> = ({ instructors }) => {
    const [ref, { width }] = useElementSize();

    const instructorsArray = instructors.map((instructor, i) => <span key={i}>{`${instructor.user_name}`}</span>);

    const maxWidth = 350;
    const showTooltip = width && width > maxWidth;

    return (
        <InstructorsParent>
            <MeasureWidth ref={ref} aria-hidden={true}>
                {instructorsArray}
            </MeasureWidth>
            <Tooltip arrow disableHoverListener={!showTooltip} title={<TooltipTitle>{instructorsArray}</TooltipTitle>}>
                <StyledInstructors $maxWidth={maxWidth}>{instructorsArray}</StyledInstructors>
            </Tooltip>
        </InstructorsParent>
    );
};

export default Instructors;
